module.exports = __webpack_public_path__ + "assets/img/afc379c9b85a5fd4a9eeaae635162c2d.png";